import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { applyTheme, fetchSiteTheme } from "./lib/theme";
import RedirectHandler from "./components/feature/RedirectHandler";
import PageViewTracker from "./components/feature/PageViewTracker";
import HashScrollHandler from "./components/feature/HashScrollHandler";
import ErrorBoundary from "./components/feature/ErrorBoundary";
import DebugPanel from "./components/feature/DebugPanel";

function App() {
  useEffect(() => {
    let cancelled = false;
    const apply = () => {
      fetchSiteTheme()
        .then((t) => {
          if (!cancelled) applyTheme(t);
        })
        .catch(() => {});
    };
    apply();
    window.addEventListener("theme-updated", apply);
    return () => {
      cancelled = true;
      window.removeEventListener("theme-updated", apply);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RedirectHandler />
        <PageViewTracker />
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
        {/* Roda depois do roteador: garante que a rolagem até a âncora
            (#secao) vença o "voltar ao topo" da troca de página. */}
        <HashScrollHandler />
        <DebugPanel />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;